import React, { useState, useEffect } from 'react';
import api from '../../api/auth';

const ParentMessages = () => {
  const [messages, setMessages] = useState([]);
  const [teachers, setTeachers] = useState([]);
  const [children, setChildren] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [selectedChild, setSelectedChild] = useState('');
  const [selectedTeacher, setSelectedTeacher] = useState('');
  const [subject, setSubject] = useState('');
  const [body, setBody] = useState('');
  const [error, setError] = useState(null);

  useEffect(() => {
    console.log('🎯 [Messages] Composant monté');
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const token = localStorage.getItem('token');
      const headers = { Authorization: `Bearer ${token}` };

      console.log('🎯 [Messages] Token:', token ? 'OK' : 'MANQUANT');

      // Charger les enfants
      const childRes = await api.get('/parent/children', { headers });
      console.log('🎯 [Messages] Réponse enfants:', childRes.data);

      let childList = childRes.data;
      if (childList && childList.data) childList = childList.data;
      if (!Array.isArray(childList)) childList = [];

      console.log('🎯 [Messages] Liste enfants finale:', childList);
      setChildren(childList);

      // Charger les messages
      const msgRes = await api.get('/parent/messages', { headers });
      console.log('🎯 [Messages] Messages:', msgRes.data);
      setMessages(Array.isArray(msgRes.data) ? msgRes.data : []);
    } catch (err) {
      console.error('❌ [Messages] Erreur:', err);
      setError(err.response?.data?.error || err.message);
    } finally {
      setLoading(false);
    }
  };

  const loadTeachers = async (childId) => {
    try {
      const token = localStorage.getItem('token');
      console.log('🎯 [Messages] Chargement profs pour enfant:', childId);

      const res = await api.get(`/parent/children/${childId}/teachers`, {
        headers: { Authorization: `Bearer ${token}` }
      });

      console.log('🎯 [Messages] Profs reçus:', res.data);
      setTeachers(Array.isArray(res.data) ? res.data : []);
    } catch (err) {
      console.error('❌ [Messages] Erreur profs:', err);
      setTeachers([]);
    }
  };

  const handleChildChange = (e) => {
    const id = e.target.value;
    console.log('🎯 [Messages] Enfant sélectionné:', id);
    setSelectedChild(id);
    setSelectedTeacher('');
    if (id) loadTeachers(id);
  };

  const handleSend = async (e) => {
    e.preventDefault();
    if (!selectedChild || !selectedTeacher || !body) {
      alert('Veuillez remplir tous les champs');
      return;
    }

    try {
      const token = localStorage.getItem('token');
      console.log('🎯 [Messages] Envoi:', { selectedChild, selectedTeacher, subject, body });

      await api.post('/parent/messages', {
        to_user_id: selectedTeacher,
        student_id: selectedChild,
        subject: subject,
        body: body,
      }, {
        headers: { Authorization: `Bearer ${token}` }
      });

      setSubject('');
      setBody('');
      setShowForm(false);
      setSelectedChild('');
      setSelectedTeacher('');
      alert('✅ Message envoyé !');
      fetchData();
    } catch (err) {
      console.error('❌ [Messages] Erreur envoi:', err);
      alert('❌ Erreur : ' + (err.response?.data?.error || err.message));
    }
  };

  if (loading) return <div className="p-6">Chargement...</div>;

  return (
    <div className="space-y-6">
      <div className="flex justify-between items-center">
        <div>
          <h1 className="text-2xl font-bold text-[#2C3E50]">💬 Messagerie</h1>
          <p className="text-gray-500">Échangez avec les professeurs de vos enfants</p>
        </div>
        <button
          onClick={() => setShowForm(!showForm)}
          className="bg-[#E67E22] text-white px-4 py-2 rounded-lg hover:bg-[#D35400]"
        >
          {showForm ? 'Annuler' : '+ Nouveau message'}
        </button>
      </div>

      {error && (
        <div className="bg-red-100 text-red-700 p-4 rounded-lg">
          ⚠️ {error}
        </div>
      )}

      {showForm && (
        <div className="bg-white rounded-xl shadow-md p-6">
          <h3 className="font-bold mb-4">Nouveau message</h3>

          {/* Debug info */}
          <div className="bg-blue-50 p-3 rounded-lg mb-4 text-xs">
            <p><strong>Debug:</strong></p>
            <p>Enfants chargés: {children.length}</p>
            <p>Enfant sélectionné: {selectedChild || 'aucun'}</p>
            <p>Profs chargés: {teachers.length}</p>
            <p>Prof sélectionné: {selectedTeacher || 'aucun'}</p>
          </div>

          <form onSubmit={handleSend} className="space-y-4">
            <div>
              <label className="block text-sm font-medium mb-1">Enfant concerné</label>
              <select
                value={selectedChild}
                onChange={handleChildChange}
                className="w-full px-4 py-2 border rounded-lg"
                required
              >
                <option value="">-- Choisir un enfant --</option>
                {children.map((c) => (
                  <option key={c.id} value={c.id}>{c.name} ({c.class_name})</option>
                ))}
              </select>
              {children.length === 0 && (
                <p className="text-sm text-red-500 mt-1">Aucun enfant chargé - Vérifiez la console</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Professeur</label>
              <select
                value={selectedTeacher}
                onChange={(e) => setSelectedTeacher(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                required
                disabled={!selectedChild}
              >
                <option value="">-- Choisir un professeur --</option>
                {teachers.map((t) => (
                  <option key={t.id} value={t.id}>{t.name}</option>
                ))}
              </select>
              {selectedChild && teachers.length === 0 && (
                <p className="text-sm text-yellow-600 mt-1">Aucun professeur pour cette classe</p>
              )}
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Sujet</label>
              <input
                type="text"
                value={subject}
                onChange={(e) => setSubject(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                placeholder="Ex: Question sur les devoirs"
              />
            </div>

            <div>
              <label className="block text-sm font-medium mb-1">Message</label>
              <textarea
                value={body}
                onChange={(e) => setBody(e.target.value)}
                className="w-full px-4 py-2 border rounded-lg"
                rows="5"
                required
              />
            </div>

            <button
              type="submit"
              className="bg-[#E67E22] text-white px-6 py-2 rounded-lg hover:bg-[#D35400]"
            >
              Envoyer
            </button>
          </form>
        </div>
      )}

      <div className="bg-white rounded-xl shadow-md overflow-hidden">
        {messages.length === 0 ? (
          <div className="p-8 text-center text-gray-500">Aucun message</div>
        ) : (
          <div className="divide-y">
            {messages.map((msg) => (
              <div key={msg.id} className="p-4 hover:bg-gray-50">
                <div className="flex justify-between items-start">
                  <div>
                    <p className="font-semibold text-[#2C3E50]">
                      {msg.from_me ? `À : ${msg.to_name}` : `De : ${msg.from_name}`}
                    </p>
                    {msg.subject && <p className="text-sm text-gray-600">📌 {msg.subject}</p>}
                    <p className="text-sm text-gray-500 mt-1">👧 {msg.student_name}</p>
                    <p className="text-sm mt-2">{msg.body}</p>
                  </div>
                  <span className="text-xs text-gray-400">{msg.created_at}</span>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </div>
  );
};

export default ParentMessages;